<template>    
    <div>
        <button @click="$refs['editProfileModal'].show('edit-profile-modal')" class="btn btn-sm btn-secondary mt-3">Edit</button>

        <b-modal size="xl" id="edit-profile-modal" ref="editProfileModal" :ok-only="true" ok-title="Close" @hidden="reload">
            <template #modal-title>
                Edit your profile
            </template>
            <div class="d-block">
                <b-tabs content-class="mt-3">
                    <b-tab title="Profile" active>
                        <meta-profile-info-component :is-onboarding="false" :edit="true"></meta-profile-info-component>
                    </b-tab>
                    <b-tab title="Bio">
                        <bio-component :is-onboarding="false" :edit="true"></bio-component>
                    </b-tab>
                    <b-tab title="Profile Image">
                        <user-avatar-component :edit="true"></user-avatar-component>
                    </b-tab>
                    <b-tab title="Genres">
                        <genres-component :is-onboarding="false" :edit="true"></genres-component>
                    </b-tab>
                    <b-tab title="Username">
                        <username-selection-component :edit="true"></username-selection-component>
                    </b-tab>
                </b-tabs>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
        },

        data() {
            return {};
        },

        mounted() {
        },

        computed: {
        },

        methods: {
            // Reload for force visibility of changes
            reload() {
                location.href = window.virtuoso.user.profileUrl ?? location.href;
            }
        }
    }
</script>
